import { render, staticRenderFns } from "./BaseInputRadio.vue?vue&type=template&id=527d9855&scoped=true"
import script from "./BaseInputRadio.vue?vue&type=script&lang=js"
export * from "./BaseInputRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d9855",
  null
  
)

export default component.exports